// Copyright (c) Move Closer 2023.

import gql from 'graphql-tag'
import { IConfiguration } from '@movecloser/front-core'

import { QueryRegistryFactory } from '../../../contexts'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const profileCompanyQueries: QueryRegistryFactory = (config: IConfiguration) => {
  return ({
    company: {
      type: 'query',
      query: gql`
        query {
          company {
            company_admin {
              firstname
              lastname
              email
            }
            email
            id
            legal_address {
              street
              city
              region {
                region_id
                region_code
                region
              }
              postcode
              country_code
              telephone
            }
            legal_name
            name
            reseller_id
#            roles {
#              items {
#                id
#                name
#                users_count
#              }
#              total_count
#            }
            vat_tax_id
          }
        }
      `,
      meta: {
        noAuth: false
      }
    },

    createCompany: {
      type: 'mutation',
      query: gql`
        mutation (
            $input: CompanyCreateInput!
        ) {
          createCompany (
            input: $input
          ) {
            company {
              company_admin {
                firstname
                lastname
                email
              }
              email
              id
              legal_address {
                street
                city
                region {
                  region_id
                  region_code
                  region
                }
                postcode
                country_code
                telephone
              }
              legal_name
              name
              reseller_id
              roles {
                items {
                  id
                  name
                  users_count
                }
                total_count
              }
              vat_tax_id
            }
          }
        }
      `,
      meta: {
        noAuth: true
      }
    },

    isCompanyEmailAvailable: {
      type: 'query',
      query: gql`
        query($email: String!) {
            isCompanyEmailAvailable (
            email: $email
          ) {
            is_email_available
          }
        }`,
      meta: {
        noAuth: true
      }
    },

    shortCreateCompany: {
      type: 'mutation',
      query: gql`
        mutation($input: ShortCreateCompanyInput!) {
          shortCreateCompany(
            input: $input
          ) {
            company {
              company_admin {
                firstname
                lastname
                email
              }
              email
              id
              legal_address {
                street
                city
                region {
                  region_id
                  region_code
                  region
                }
                postcode
                country_code
                telephone
              }
              legal_name
              name
              vat_tax_id
            }
          }
        }
      `,
      meta: {
        noAuth: true
      }
    },

    updateCompany: {
      type: 'mutation',
      query: gql`
        mutation($input: CompanyUpdateInput!) {
          updateCompany(
            input: $input
          ) {
            company {
              company_admin {
                firstname
                lastname
                email
              }
              email
              id
              legal_address {
                street
                city
                region {
                  region_id
                  region_code
                  region
                }
                postcode
                country_code
                telephone
              }
              legal_name
              name
              roles {
                items {
                  id
                  name
                  users_count
                }
                total_count
              }
              vat_tax_id
            }
          }
        }
      `,
      meta: {
        noAuth: false
      }
    },

    updateCompanyUser: {
      type: 'mutation',
      query: gql`
        mutation($input: CompanyUserUpdateInput!) {
          updateCompanyUser(
            input: $input
          ) {
            user {
              email
              firstname
              lastname
            }
          }
        }
      `,
      meta: {
        noAuth: false
      }
    }
  })
}
